import React, { MouseEvent } from "react"
import { MobergButton, MobergHoverRow, MobergIconSize, MobergText, MobergTheme } from "../../../../Moberg"
import { MdClose, MdDragIndicator } from "react-icons/md"
import { SortableElement, SortableHandle } from "react-sortable-hoc"
import styled from "styled-components"
import { ModalityGraphConfig } from "../../../../Pages/Data/Visualize/DataReview/Types/Graph"
import { useDataReviewPermissions } from "../../../../Hooks/useDataReviewPermissions"
import { permissionTooltip } from "../../../../Utils/permissionUtils"

type GraphToggleButtonProps = {
	graph: ModalityGraphConfig
	isActive: boolean
	setSelectedGraphId: (graphId: string) => void
	removeGraph: (graphId: string) => void
}

export const GraphToggleButton = SortableElement(({ graph, isActive, setSelectedGraphId, removeGraph }: GraphToggleButtonProps) => {
	const { canManageDataReview } = useDataReviewPermissions()

	const handleDeleteGraph = (event: MouseEvent<HTMLButtonElement>) => {
		event.stopPropagation()
		removeGraph(graph.id)
	}

	return (
		<li style={{ listStyleType: "none", whiteSpace: "nowrap", margin: 0, background: "var(--color-surface-panel)", borderRadius: "4px", zIndex: 9999 }}>
			<MobergHoverRow theme={isActive ? MobergTheme.BLUE : MobergTheme.BLACK} active={isActive} onClick={() => setSelectedGraphId(graph.id)} style={{ padding: "0 8px" }}>
				<DragHandle />

				<div style={{ flex: 1, padding: "9px 16px", whiteSpace: "nowrap", minWidth: "220px" }}>
					<MobergText style={{ color: "inherit" }}>
						{graph.name}
					</MobergText>
				</div>

				<MobergButton theme={isActive ? MobergTheme.ON_BLUE : MobergTheme.ON_GRAY} onClick={handleDeleteGraph} style={{ padding: "2px", color: "inherit" }} disabled={!canManageDataReview} tooltip={permissionTooltip(canManageDataReview)}>
					<MdClose size={MobergIconSize.REGULAR} />
				</MobergButton>
			</MobergHoverRow>
		</li>
	)
})

const DragHandle = SortableHandle(() => (
	<Handle>
		<MdDragIndicator size={MobergIconSize.SMALL} />
	</Handle>
))

const Handle = styled.div`
	height: 32px;
	display: flex;
	align-items: center;
	padding: 0 8px;
	cursor: grab;

	&:active {
		cursor: grabbing;
	}
`
